// ============================================================================
// Image Fallback Helper — Universal `<img onError>` pattern Stage 1
// ============================================================================
// Refactor dari 5 inline copy-paste pattern post-`e696b4b` ke single source.
// Saat foto kandidat gagal load (CORS, 404, expired CDN signed URL), tile
// JANGAN blank — kasih sinyal visual ke operator bahwa image fail.
//
// Pattern: keep <img> element visible tapi swap content jadi surface bg +
// 0.3 opacity + tooltip "⚠ Image failed to load". Operator hover dapat
// info kalau image broken (vs network slow / not yet loaded).
//
// Usage:
//   import { handleImgFail } from '../lib/imgFallback';
//   <img src={url} onError={handleImgFail} />
//
// Untuk pattern alternative (hide-parent atau elaborate ⚠ glyph element),
// JANGAN pakai helper ini — biarin custom inline. Lihat OsintTab.jsx:1654
// (hide-parent) atau OsintTab.jsx:1814 (⚠ glyph element) sebagai contoh.
// ============================================================================

/**
 * Universal img onError handler — show subtle placeholder instead of blank tile.
 * Idempotent — kalau sudah di-fallback (dataset flag set), skip untuk cegah loop.
 *
 * @param {Event} ev - React synthetic event from <img onError>
 */
export function handleImgFail(ev) {
  if (ev.target.dataset.imgFallback) return; // already handled, prevent loop
  ev.target.dataset.imgFallback = '1';
  ev.target.style.background = 'var(--color-surface)';
  ev.target.style.opacity = '0.3';
  ev.target.removeAttribute('src');
  ev.target.title = '⚠ Image failed to load';
}
